import { Button, Divider, Input, Modal, Select } from "antd";
import { useState } from "react";
import { toastError, toastSuccess } from "../../utils/toast";
import { apiUpdateProviderTMDTCurrent } from "../../api";
import { useLoading } from "../../context/LoadingContext";
import { systemProviderTMDTOptions } from "../../assets/constants/default_option";

export default function ModalProviderTMDT({ isOpen, setIsOpen, data, fetchData }: any) {
    const [providerValue, setProviderValue] = useState('')
    const [otpConfirm, setOtpConfirm] = useState('')

    const { setIsLoading } = useLoading()

    const handleUpdate = async () => {
        if (!providerValue) {
            toastError('Vui lòng chọn nhà cung cấp!')
            return
        }
        if (data === providerValue) {
            toastError('Vui lòng chọn nhà cung cấp khác!')
            return
        }
        if (!otpConfirm) {
            toastError('Vui lòng nhập mã OTP xác nhận!')
            return
        }

        try {
            setIsLoading(true)
            const resp = await apiUpdateProviderTMDTCurrent({
                value: providerValue,
                otpConfirm: otpConfirm,
            })
            if (resp.status === 200) {
                fetchData()
                setIsOpen(false)
                toastSuccess('Cập nhật thành công')
                setOtpConfirm('')
                setProviderValue('')
            }
        } catch (error) {
            toastError('Cập nhật thất bại')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            title="Cập nhật nhà cung cấp gói TMDT"
            open={isOpen}
            onCancel={() => setIsOpen(false)}
            footer={[
                <Button onClick={handleUpdate} type="primary">
                    Cập nhật
                </Button>
            ]}
        >
            <p><span style={{ color: 'red' }}>*</span> Chọn nhà cung cấp</p>
            <Select
                style={{ width: '100%' }}
                placeholder="Chọn nhà cung cấp"
                value={providerValue}
                onChange={value => setProviderValue(value)}
                options={systemProviderTMDTOptions}
            />
            <p><span style={{ color: 'red' }}>*</span> Nhập mã OTP xác nhận</p>
            <Input value={otpConfirm} onChange={e => setOtpConfirm(e.target.value)} />
            <Divider />
        </Modal>
    )
}
